"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AuPlate = _interopRequireDefault(require("./AuPlate"));
var _AuButton = _interopRequireDefault(require("./AuButton"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _context;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "container": "generic_error-module__container___BXo7x",
  "msg": "generic_error-module__msg___pgiMz",
  "button": "generic_error-module__button____9jc0"
};
class GenericError extends _react.default.Component {
  static propTypes = {
    history: T.shape({
      push: T.func.isRequired,
      goBack: T.func.isRequired,
      location: T.shape({
        hash: T.string.isRequired
      }).isRequired
    }).isRequired,
    code: T.oneOfType([T.number, T.string]).isRequired,
    className: T.string,
    titleDisplay: T.string,
    titleDisplayId: T.string,
    messageDisplay: T.string,
    messageDisplayId: T.string
  };
  onBackBtnClick = (0, _bind.default)(_context = this.onBackBtnClick).call(_context, this);
  onBackBtnClick() {
    const {
      history: browserHistory
    } = this.props;
    // if location hash exists - we were navigated here from the KC.
    return browserHistory.location.hash ? browserHistory.push('/') : browserHistory.goBack();
  }
  render() {
    const {
      code,
      className,
      titleDisplay,
      titleDisplayId,
      messageDisplay,
      messageDisplayId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className)
    }, /*#__PURE__*/_react.default.createElement(_AuPlate.default, {
      contentDisplay: code,
      titleDisplay: titleDisplay,
      titleDisplayId: titleDisplayId
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.msg,
      displayId: messageDisplayId,
      displayString: messageDisplay,
      tag: "div"
    }), /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      type: "primary",
      displayId: "au.goBack",
      className: styles.button,
      onClick: this.onBackBtnClick
    }));
  }
}
exports.default = GenericError;